export default {
	title: 'settings',
	components: [
		{ title: 'device_profile', component: 'rgbww_g3_profile' },
		{
			title: 'high_frequency_mode',
			component: 'high_frequency_mode_g2',
			min_ver: '2.0.0',
		},
		{ title: 'input_output', component: 'input_output_g3_rgbww' },
		{ title: 'analog_input_settings', component: 'analog_input_settings_g2' },
		{
			title: 'enable_input',
			component: 'enable_input_per_id_g2',
			min_ver: '1.0.7',
		},
		{ title: 'invert_switch', component: 'invert_switch_per_id_g2' },
		{ title: 'dimming', component: 'dimming_behavior_g2' },
		{ title: 'button_fade_rate', component: 'button_fade_rate_g2' },
		{
			title: 'range_map',
			component: 'range_map_g2',
			supported_mode: ['light', 'cct'],
			requires_config_key: 'range_map',
		},
		{
			title: 'ct_range',
			component: 'ct_range_g2',
			supported_mode: 'cct',
			requires_config_key: 'ct_range',
		},
		{ title: 'button_presets', component: 'button_presets_prorgbww' },
		{
			title: 'min_brightness_on_toggle',
			component: 'min_brightness_on_toggle_g2',
		},
		{ title: 'transition_duration', component: 'transition_g2' },
		{ title: 'device_name', component: 'device_name_g2' },
		{
			title: 'device_card_customization',
			component: 'customize_device_content',
		},
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
